import { getExtension } from '../utils/formaters';
import { getManagerId } from '../utils/functions';
export const TableScheduleListDtoToTableScheduleListItem = (tableScheduleList) => tableScheduleList.map(dto => ({
    id: dto.atendimentoId || '-',
    statusId: dto.sStatusId || '-',
    serviceStatus: dto.atendimentoStatus || '-',
    openDate: dto.dataAbertura || '-',
    scheduleDate: dto.dataAgendamento || '-',
    rescheduleDate: dto.dataReagendamento || null,
    county: dto.municipio || '-',
    uf: dto.uf || '-',
    plate: dto.placa || '-',
}));
export const TableScheduleListDtoToTableScheduleList = (tableSchedule) => ({
    itens: TableScheduleListDtoToTableScheduleListItem(tableSchedule.listagem),
    pageCount: tableSchedule.totalPaginas,
    rows: tableSchedule.totalRegistros,
});
export const TableScheduleListDtoToTableScheduleCancelItem = (dto) => ({
    atendimentoId: dto.id,
    sStatusId: dto.statusId,
    atendimentoStatus: dto.serviceStatus,
    dataAbertura: dto.openDate,
    dataAgendamento: dto.scheduleDate,
    dataReagendamento: dto.rescheduleDate,
    municipio: dto.county,
    uf: dto.uf,
    placa: dto.plate,
    gestorId: dto.managerId || '',
});
export const scheduleVehicleDtoToScheduleVehicle = (dto) => ({
    fleetId: dto.frotaId || '',
    personId: dto.pessoaId || '',
    currentKm: dto.valorKm || 0,
});
export const scheduleServiceListDtoToScheduleServiceList = (scheduleServiceDto) => scheduleServiceDto?.map(dto => ({
    id: dto.id || '',
    name: dto.nome || '',
}));
const scheduleFilesToScheduleFilesDto = (symptoms, files) => {
    const possibleNames = symptoms?.map(item => ({
        id: item.id,
        name: item.details
            .flatMap(item => item.name)
            .join('_')
            .replace(/ /g, '_'),
    }));
    const newImages = files?.map((item, index) => {
        const matchedId = possibleNames.filter(name => name.id === item.id);
        if (matchedId)
            return {
                file: item.file,
                name: (matchedId[0]?.name || 'ObservaçõesGerais') +
                    index +
                    getExtension(item.file.trim()),
            };
        return null;
    });
    return newImages;
};
const scheduleSymptomsToScheduleSymptomsDto = (symptoms) => symptoms?.map(symptom => ({
    detalhes: symptom.details?.map(detail => detail.name),
    observacao: symptom.observation,
}));
export const createScheduleDtoToCreateSchedule = (body) => ({
    arquivos: scheduleFilesToScheduleFilesDto(body.symptoms, body.files),
    celular: body.phone,
    dataAgendamento: body.scheduleDate + ' ' + body.scheduleTime,
    email: body.email,
    endereco: body.address,
    frotaId: body.fleetId,
    kmAtual: body.currentKm,
    nome: body.name,
    observacao: body.observation,
    pessoaID: body.personId,
    placa: body.plate,
    sintomas: scheduleSymptomsToScheduleSymptomsDto(body.symptoms),
});
const errorsDtoToErros = (errors) => errors?.map(error => ({
    line: error.Indice || '-',
    error: error.Log || '-',
    plate: error.Placa || '-',
    service: error.ItemServico || '-',
    observations: error.ObservacoesGerais || '-',
    km: error.KMVeiculo || '-',
}));
export const multipleDtoToMultiple = (data) => {
    if (data.VeiculosEnviados && data.Errors)
        return {
            sentVehicles: data.VeiculosEnviados,
            errors: errorsDtoToErros(data.Errors),
            personID: data.PessoaId,
            plates: data.Placas,
        };
    return null;
};
export const MultipleToMultipleDto = ({ plates, body }) => {
    return {
        dataAgendamento: body.scheduleDate + ' ' + body.scheduleTime,
        pessoaID: body.personId,
        celular: body.phone,
        nome: body.name,
        endereco: body.address,
        email: body.email,
        gestorId: getManagerId(),
        placas: plates,
    };
};
